import { useTranslation } from "react-i18next";
import { convertPersian, delay, fileToformData, regexFormater, validateInput } from "../../../../tools/tools";

import styles from "./profile.module.scss";
import { Form, Row, Col, Input, Select, Button } from "antd";
import DatePicker from "../../../../components/dataPicker/datePicker";
import ResizeImages from "../../../../components/resizeImages/resizeImg";
import SteperNewProfile from "../modules/steper";
import { useEffect, useState } from "react";
import { useAPIPublic, useTenders } from "../../../../tools/api";
import { CheckToken, DocType, setToken } from "../../../../tools/services";
import { useDispatch, useSelector } from "react-redux";
import { simcardPurchase } from "../../../../reducer/serviceReducer";
import ReactInputMask from "react-input-mask";
import Loading from "../../../../components/loader/loading";
import { _adr } from "../../../../address";
import { useNavigate, useLocation } from "react-router-dom";
import Layouts, { useLayouts } from "../../../layout/layouts";
const Profile = () => {
  const { queryGender, addDocument } = useAPIPublic();
  const { queryProfileByCertNoVBirthDate, addProfile, queryCountSimCardByCertNo } = useTenders();

  const [t] = useTranslation("global");

  const nav = useNavigate();
  const location = useLocation();

  const [frmProfile] = Form.useForm();

  const dispatch = useDispatch();
  const formData = useSelector((state) => state?.from?.newUser);

  const [initialData, setInitialData] = useState({
    counterSim: "-1",
  });

  const [gender, setGender] = useState([]);
  const [postalcode, setPostalcode] = useState("");
  const [valMsisdn, setValMsisdn] = useState(location?.state?.msisdn || "");

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const initialData = async () => {
      try {
        setLoading(true);
        const response = await queryGender();
        if (response) {
          setGender(response);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    };
    initialData();
  }, [useAPIPublic]);

  const { _currentUser } = useSelector((state) => {
    return state?.another;
  });

  const { refreshUser, checkLoginUser } = useLayouts();

  //check Login
  const [isLogin, setLogin] = useState();

  //user Info
  const [user, setUser] = useState({});

  useEffect(() => {
    const checkLogin = async () => {
      const isCheck = await checkLoginUser();
      if (isCheck) {
        const userInfo = await refreshUser();
        setUser(userInfo || {});
        if (formData?.hasCompleted && !formData?.hasCompleted) {
          setLogin(false);
        } else {
          setLogin(isCheck);
        }
      }
    };
    checkLogin();
  }, [checkLoginUser, refreshUser]);

  const handleGetDate = (temp) => {
    frmProfile.setFieldValue("birthdate", temp);
    setServProfile((prev) => ({ ...prev, birtday: temp }));
  };

  //#region Check Counter Sim card Activated =======

  const handleCountSim = async (e) => {
    setServProfile((prev) => ({ ...prev, certNo: e.target.value }));
    if (e.target.value.length === 10 && e.target.value !== servProfile?.prevCertNo) {
      let payload = {
        certno: e.target.value,
      };
      let response = await queryCountSimCardByCertNo(payload);
      if (response != null) {
        setServProfile((prev) => ({ ...prev, prevCertNo: e.target.value }));
        if (response === 0) {
          setInitialData((prev) => ({
            ...prev,
            firstSimCard: true,
            counterSim: response,
          }));
        } else {
          setInitialData((prev) => ({ ...prev, counterSim: response?.Result }));
        }
      }
    }
  };
  //#endregion Check Counter Sim card Activated =======

  const handleGetImage = async (value) => {
    frmProfile.setFieldValue("photo", value);
  };

  useEffect(() => {
    frmProfile.setFieldValue("smsmobileno", valMsisdn);
  }, [valMsisdn]);

  useEffect(() => {
    if (formData?.profile) {
      frmProfile.setFieldsValue({
        certno: formData?.profile?.certno,
        birthdate: formData?.profile?.birthdate,
        fname: formData?.profile?.fname,
        lname: formData?.profile?.lname,
        fathername: formData?.profile?.fathername,
        gender: formData?.profile?.gender,
        identityno: formData?.profile?.identityno,
        // smsmobileno: formData?.profile?.smsmobileno,
        photo: formData?.profile?.photo,
      });

      if (!isLogin) {
        frmProfile.setFieldValue("smsmobileno", formData?.profile?.smsmobileno);
        setValMsisdn(formData?.profile?.smsmobileno);
      }
    }
  }, [formData]);

  const [servProfile, setServProfile] = useState({
    birtday: "",
    prevBirtday: "",
    certNo: "",
    prevCertNo: "",
  });
  useEffect(() => {
    const handleReadProfile = async () => {
      if (servProfile.certNo.length === 10 && servProfile.birtday.length > 0) {
        if (servProfile.birtday !== servProfile.prevBirtday || servProfile.certNo !== servProfile.prevCertNo) {
          let payload = {
            certno: servProfile.certNo,
            birthdate: servProfile.birtday,
          };
          setLoading(true);
          let response = await queryProfileByCertNoVBirthDate(payload);
          if (response) {
            setServProfile((prev) => ({
              ...prev,
              prevBirtday: servProfile.birtday,
              prevCertNo: servProfile.certNo,
            }));
            frmProfile.setFieldsValue({
              fname: response?.fname,
              lname: response?.lname,
              fathername: response?.fathername,
              gender: response?.gender,
              identityno: response?.identityno,
            });
            if (isLogin) {
              frmProfile.setFieldValue("smsmobileno", response?.smsmobileno.toString().replace("9", ""));
              setValMsisdn("09" + response?.smsmobileno.toString().replace("9", ""));
            }

            // document.getElementById("refMsisdn")?.value = response?.smsmobileno.toString().replace("9", "");
            if (response?.address?.postalcode?.length > 0) {
              // frmProfile.setFieldValue("postalcode", response?.address?.postalcode);
              setPostalcode(response?.address?.postalcode);
              // setPostalCodeServ((prev) => ({
              //   ...prev,
              //   postCode: response?.address?.postalcode,
              // }));
            }
          }
          setLoading(false);
        }
      }
    };
    handleReadProfile();
  }, [servProfile.certNo, servProfile.birtday]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      const resDoc = await addDocument(await fileToformData(values.photo), DocType.CertNoCard);
      if (resDoc) {
        let payload = {
          fname: values.fname,
          lname: values.lname,
          fathername: values.fathername,
          identityno: values.identityno,
          certno: values.certno,
          birthdate: values.birthdate.replace(/\//g, "-"),
          smsmobileno: regexFormater(values.smsmobileno).removeSpace(),
          gender: values.gender,
          profiletype: 23,
          nationality: "",
          documentid: resDoc.Result,
        };
        await delay();
        let resProfile = await addProfile(payload);
        if (resProfile) {
          let txtGender = gender.find((item) => item.value === frmProfile.getFieldValue("gender"))?.name;
          await setToken(resProfile?.tokenInfo);
          if (!isLogin) {
            dispatch(
              simcardPurchase({
                newUser: {
                  profile: {
                    ...formData?.profile,
                    ...values,
                    profileid: resProfile.profileId,
                    postalcode: postalcode,
                    txtGender: txtGender,
                  },
                  hasCompleted: false,
                },
              }),
            );
            nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Address);
          } else {
            nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review);
          }
        }
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };
  return (
    <>
      <SteperNewProfile current={0} />
      <div className={styles.profile}>
        <div className={styles.address}>
          <div className="page_title">
            <h3>اطلاعات هویتی </h3>
          </div>
          <Form id="frmProfile" form={frmProfile} onFinish={handleSubmit} layout="vertical">
            <Row gutter={30}>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item
                  name="certno"
                  label="کدملی"
                  rules={[
                    validateInput({
                      t: t,
                      validate: true,
                      length: 10,
                    }),
                  ]}
                  extra={
                    <>
                      {initialData.counterSim !== "-1" && (
                        <span className="holder-result">
                          شما میتوانید <span>{10 - initialData.counterSim}</span> سیمکارت دیگر خریداری کنید{" "}
                        </span>
                      )}
                    </>
                  }
                >
                  <Input
                    maxLength={10}
                    inputMode="numeric"
                    dir="ltr"
                    onBlur={(e) => {
                      e.target.value = convertPersian(e.target.value);
                      setServProfile((prev) => ({ ...prev, certNo: e.target.value }));
                      handleCountSim(e);
                    }}
                    onChange={(e) => (e.target.value = convertPersian(e.target.value))}
                    autoComplete="off"
                    placeholder="کدملی خود را وارد کنید"
                  />
                </Form.Item>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item name="birthdate" rules={[validateInput({ t: t, validate: true })]} label="تاریخ تولد">
                  <DatePicker values={frmProfile.getFieldValue("birthdate")} onChange={handleGetDate} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={30}>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item
                  name="fname"
                  label="نام"
                  rules={[
                    validateInput({
                      t: t,
                      validate: true,
                      type: "persian",
                    }),
                  ]}
                >
                  <Input maxLength={64} onChange={(e) => (e.target.value = convertPersian(e.target.value))} autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item
                  name="lname"
                  label="نام خانوادگی"
                  rules={[
                    validateInput({
                      t: t,
                      validate: true,
                      type: "persian",
                    }),
                  ]}
                >
                  <Input maxLength={64} onChange={(e) => (e.target.value = convertPersian(e.target.value))} autoComplete="off" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={30}>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item
                  name="fathername"
                  label="نام پدر"
                  rules={[
                    validateInput({
                      t: t,
                      validate: true,
                      type: "persian",
                    }),
                  ]}
                >
                  <Input maxLength={32} onChange={(e) => (e.target.value = convertPersian(e.target.value))} autoComplete="off" />
                </Form.Item>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item name="gender" label="جنسیت" rules={[validateInput({ t: t, validate: true })]}>
                  <Select>
                    {gender.map((item, key) => (
                      <Select.Option key={key} value={item.value}>
                        {item.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={30}>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item
                  name="identityno"
                  label="شماره شناسنامه"
                  rules={[
                    validateInput({
                      t: t,
                      validate: true,
                      type: "number",
                    }),
                  ]}
                >
                  <Input
                    dir="ltr"
                    inputMode="numeric"
                    onChange={async (e) => {
                      e.target.value = await convertPersian(e.target.value);
                    }}
                    maxLength={10}
                    autoComplete="off"
                  />
                </Form.Item>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item
                  className="input-normal"
                  name="smsmobileno"
                  label={"شماره همراه"}
                  rules={[
                    validateInput({
                      t: t,
                      validate: true,
                      type: "msisdnOrg",
                    }),
                  ]}
                >
                  <div>
                    <ReactInputMask
                      disabled={isLogin ? false : true}
                      mask="0\999 99 99 999"
                      id="refMsisdn"
                      value={frmProfile.getFieldValue("smsmobileno")?.toString()?.length > 0 ? frmProfile.getFieldValue("smsmobileno") : ""}
                      onChange={(e) => {
                        e.target.value = convertPersian(e.target.value);
                        setValMsisdn(e.target.value);
                      }}
                      className="msisdn-mask"
                      dir="ltr"
                    />
                  </div>
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={30}>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item
                  name="email"
                  label="پست الکترونیکی"
                  rules={[
                    validateInput({
                      t: t,
                      validate: false,
                      type: "email",
                    }),
                  ]}
                >
                  <Input
                    dir="ltr"
                    inputMode="email"
                    onChange={async (e) => {
                      e.target.value = await convertPersian(e.target.value);
                    }}
                    maxLength={32}
                    autoComplete="off"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={30}>
              <Col xxl={8} xl={8} lg={8} md={12} sm={12} xs={24}>
                <Form.Item name="photo" rules={[validateInput({ t: t, validate: true })]} label="تصویر مدرک">
                  <ResizeImages exportImage={handleGetImage} />
                </Form.Item>
              </Col>
              <Col xxl={8} xl={8} lg={8} md={10} sm={12} xs={24}></Col>
            </Row>
          </Form>
          {isLogin ? (
            <>
              <div className="holder-button">
                <Button form="frmProfile" key={frmProfile} htmlType="submit" className="btn-aptel">
                  ویرایش
                </Button>
                <Button onClick={() => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Review)}>
                  انصراف
                </Button>
              </div>
            </>
          ) : (
            <div className="holder-button">
              <Button form="frmProfile" key={frmProfile} htmlType="submit" className="btn-aptel">
                مرحله بعد
              </Button>
              <Button>انصراف</Button>
            </div>
          )}
        </div>
      </div>

      <Loading isOpen={loading} />
    </>
  );
};

export default Profile;
